module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Play-eb8a8663e2f453f3f57e083577830882411a32df48cee713689af1e92b35406f.svg";